import { create } from 'zustand';
import i18n from '../i18n/config';

interface LanguageStore {
  language: string;
  setLanguage: (lang: string) => void;
}

const STORAGE_KEY = 'i18n_language';

// Get initial language from localStorage or default to 'en'
const getInitialLanguage = (): string => {
  const stored = localStorage.getItem(STORAGE_KEY);
  return stored || 'en';
};

export const useLanguageStore = create<LanguageStore>((set) => ({
  language: getInitialLanguage(),

  setLanguage: (lang: string) => {
    // Update i18next
    i18n.changeLanguage(lang);

    // Update localStorage
    localStorage.setItem(STORAGE_KEY, lang);

    // Update store
    set({ language: lang });
  },
}));
